@if (current(); as m) {
  <div class="mprev__scrim" (click)="close()"></div>

  <div class="mprev" role="dialog" aria-modal="true" aria-labelledby="mprev-title">
    <header class="mprev__head">
      <div class="mprev__title-block">
        <h2 class="mprev__title" id="mprev-title">{{ m.title }}</h2>
        <p class="mprev__meta">
          <span class="mprev__badge">{{ ('LIBRARY.CATEGORY.' + m.category) | translate }}</span>
          @for (line of m.meta ?? []; track $index) { · {{ line }} }
        </p>
      </div>
      <button type="button" class="mprev__close" (click)="close()"
              [attr.aria-label]="'COMMON.CLOSE' | translate">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <!-- Lecture seule : aucun geste de l'écran n'invite à emporter le fichier.
         Les lecteurs perdent leur bouton d'enregistrement, l'image son menu
         contextuel, la visionneuse PDF sa barre. -->
    <div class="mprev__body" (contextmenu)="block($event)">
      @if (loading()) {
        <div class="mprev__state"><span class="mprev__spinner"></span></div>
      } @else if (errored()) {
        <div class="mprev__state">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <p>{{ 'LIBRARY.PREVIEW.ERROR' | translate }}</p>
        </div>
      } @else {
        @switch (kind) {
          @case ('pdf') {
            <!-- Pas de sandbox : Chrome n'ouvre pas sa visionneuse PDF dans un
                 cadre bridé. Le contenu est toujours typé application/pdf
                 (retype), et la visionneuse n'exécute rien dans notre origine. -->
            <iframe class="mprev__frame" [src]="objectUrl()" [title]="m.title"></iframe>
          }
          @case ('image') {
            <img class="mprev__image" [src]="objectUrl()" [alt]="m.title" draggable="false">
          }
          @case ('video') {
            <video class="mprev__media" [src]="objectUrl()" controls preload="metadata"
                   controlslist="nodownload noremoteplayback" disablepictureinpicture></video>
          }
          @case ('audio') {
            <div class="mprev__audio-wrap">
              <i class="fa-solid fa-headphones mprev__audio-icon"></i>
              <audio class="mprev__audio" [src]="objectUrl()" controls preload="metadata"
                     controlslist="nodownload"></audio>
            </div>
          }
          @case ('external') {
            <!-- Les hébergeurs vidéo refusent l'intégration en cadre : on
                 renvoie vers la source plutôt que d'afficher un cadre vide. -->
            <div class="mprev__state">
              <i class="fa-solid fa-up-right-from-square"></i>
              <p>{{ 'LIBRARY.PREVIEW.EXTERNAL' | translate }}</p>
              <button type="button" class="mprev__btn" (click)="openExternal()">
                <i class="fa-solid fa-arrow-up-right-from-square"></i>
                {{ 'LIBRARY.PREVIEW.OPEN_LINK' | translate }}
              </button>
            </div>
          }
          @default {
            <div class="mprev__state">
              <i class="fa-solid fa-file-circle-question"></i>
              <p>{{ 'LIBRARY.PREVIEW.UNSUPPORTED' | translate }}</p>
            </div>
          }
        }
      }
    </div>
  </div>
}
